import { GetSitesQuery } from '../get-sites';

import { MOCK_SITES } from './sites-data';

export function getSites(): GetSitesQuery.Output {
  const sites = MOCK_SITES.map((site) => ({
    id: site.id,
    fullFrontendId: site.fullFrontendId,
  }));

  return {
    sites,
  };
}
